import { Link } from "react-router-dom";
import { CheckSquareFilled } from "@ant-design/icons";

import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { Button } from "@/ui-components/commonComponents/Button/Button";
import { TestDisplayName } from "@/shared/components/TestDisplayName/TestDisplayName";
import {
  ADMIN_ROUTE,
  NEW_ROUTE,
  TEST_INSTRUCTIONS_ROUTE,
  TEST_NORMS_ROUTE,
  TESTS_ROUTE,
} from "@/routing/AppRouter/routes.constants";

import style from "./style.module.css";

interface TestCreatedModalProps {
  isVisible: boolean;
  testName: string;
  internalName?: string;
  onClose: () => void;
}

export function TestCreatedModal({ isVisible, testName, internalName, onClose }: TestCreatedModalProps) {
  return (
    <BasicModal
      isModalOpen={isVisible}
      handleCancel={onClose}
      autoHeight={true}
      footer={[
        <Button key="done" onClick={onClose}>
          Done
        </Button>,
      ]}
    >
      <div>
        <h2 className={style.modalTitle}>Test Created Successfully</h2>

        <p className={style.createdLine}>
          <CheckSquareFilled className={style.checkIcon} />{" "}
          <span>
            <TestDisplayName name={testName} internalName={internalName} /> Created
          </span>
        </p>

        <h3 className={style.nextStepsLabel}>Next Steps:</h3>

        <div className={style.linkGroup}>
          <Link
            to={`/${ADMIN_ROUTE}/${TESTS_ROUTE}/${TEST_NORMS_ROUTE}/${NEW_ROUTE}`}
            className={style.linkTitle}
            onClick={onClose}
          >
            Add Norms
          </Link>
          <p className={style.linkDesc}>
            Use this link to navigate to the Add Norms page to upload norms for this test.
          </p>
        </div>

        <div className={style.linkGroup}>
          <Link to={TEST_INSTRUCTIONS_ROUTE} className={style.linkTitle} onClick={onClose}>
            Add Instructions
          </Link>
          <p className={style.linkDesc}>Use this link to navigate to the Test Instructions page for the new test.</p>
        </div>

        <div className={style.linkGroup}>
          <button type="button" className={style.linkTitle} onClick={onClose}>
            Review Elements
          </button>
          <p className={style.linkDesc}>Close this modal to review the test elements.</p>
        </div>
      </div>
    </BasicModal>
  );
}
